import React, { createContext, useEffect, useState } from 'react';


export const ActiveTabContext = createContext(true);

export const ActiveTabProvider = ({ children }: { children: React.ReactNode }) => {
  const [isTabActive, setIsTabActive] = useState(true);

  useEffect(() => {
    const listener = () => {
      if (document.hidden) {
        // wait a minute before actually setting the field so if a user is quickly switching tabs/windows we don't thrash too much
        setTimeout(() => {
          if (document.hidden) {
            setIsTabActive(false)
          }
        }, 60000)
      } else {
        setIsTabActive(true);
      }
    }
    document.addEventListener("visibilitychange", listener, false);

    return () => {
      document.removeEventListener("visibilitychange", listener)
    }
  }, [])

  return (
    <ActiveTabContext.Provider value={isTabActive}>
      {children}
    </ActiveTabContext.Provider>
  )
}
